import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

import { REACT_QUERY_KEY } from "~/core/constants/common";

import { getOpportunitiesByObject } from "~/lib/opportunities/queries";

import { useObjectOpportunitiesStore } from "../store";
import type { UseObjectOpportunitiesParams } from "../types";

export const useObjectOpportunities = ({
  object_id,
  object_type,
}: UseObjectOpportunitiesParams) => {
  const { data: objectOpportunities, isLoading: loadingObjectOpportunities } =
    useQuery({
      queryKey: [
        REACT_QUERY_KEY.OPPORTUNITIES_BY_OBJECT,
        object_id,
        object_type,
      ],
      queryFn: ({ queryKey }) =>
        getOpportunitiesByObject({
          id: queryKey[1] as string,
          entityType: object_type,
        }),
      retry: 1,
      enabled: !!object_id,
      refetchOnMount: "always",
      refetchOnWindowFocus: "always",
    });

  useEffect(() => {
    if (objectOpportunities) {
      useObjectOpportunitiesStore.setState({
        opportunities: objectOpportunities,
      });
    }
  }, [objectOpportunities]);

  return { objectOpportunities, loadingObjectOpportunities };
};

export const useInvalidateObjectOpportunities = () => {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries({
      queryKey: [REACT_QUERY_KEY.OPPORTUNITIES_BY_OBJECT],
      refetchType: "all",
    });
  };
};
